<template>
    <ProfileOptionSelector :model="'job'" :nextRoute="() => 'IncomePage'" />
</template>

<script>
export default {
    name: 'JobPage',
}
</script>
